import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAssignments as GetAssignmentsQuery,
    GetAssignments_meeting_assignments_edges as AssignmentEdge,
    GetAssignmentsVariables as GetAssignmentsVariables,
} from 'nutshell-graphql-types';

import GET_ASSIGNMENTS from '../queries/get-assignments.graphql';

export const useGetAssignments = (
    meetingId: string
): {
    teamAssignments: AssignmentEdge[];
    userAssignments: AssignmentEdge[];
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetAssignmentsQuery, GetAssignmentsVariables>(
        GET_ASSIGNMENTS,
        {
            variables: {
                meetingId,
            },
            fetchPolicy: 'cache-and-network',
        }
    );

    const meeting = data ? data.meeting : null;

    const teamAssignments = [];
    const userAssignments = [];
    if (meeting && meeting.assignments) {
        for (const assignment of meeting.assignments.edges) {
            if (assignment.node.assigneeEntity.__typename === 'Team') {
                teamAssignments.push(assignment);
            } else {
                userAssignments.push(assignment);
            }
        }
    }

    return {
        teamAssignments,
        userAssignments,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
